import { Box } from "@mui/material";
import { EMPTY_SX } from "../../../utils/empty-sx";
import { FOOTER_HEIGHT } from "./fixed-footer";

import type { SxProps } from "@mui/material";
import type { FC, ReactNode } from "react";

export const PageWithFooterWrapper: FC<{ children: ReactNode; sx?: SxProps }> = ({
  children,
  sx = EMPTY_SX,
}) => (
  <Box
    sx={[
      { display: "flex", flex: 1, height: `calc(100% - ${FOOTER_HEIGHT})` },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {children}
  </Box>
);
